import { render, staticRenderFns } from "./workers.vue?vue&type=template&id=7dd3b023&"
import script from "./workers.vue?vue&type=script&lang=js&"
export * from "./workers.vue?vue&type=script&lang=js&"
import style0 from "./workers.vue?vue&type=style&index=0&id=7dd3b023&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports